import * as React from 'react';

export function DevAuthBanner() {
  if (import.meta.env.PROD) return null;
  if (typeof localStorage === 'undefined') return null;

  const sub = localStorage.getItem('dev_clerk_sub');
  if (!sub) return null;

  return (
    <div className="bg-amber-50 border border-amber-200 text-amber-800 px-3 py-1 text-xs rounded mr-2">
      Dev: sub=<code>{sub}</code>
    </div>
  );
}
